import { render, staticRenderFns } from "./introduceDetail.vue?vue&type=template&id=07998c1a&scoped=true&lang=pug&"
import script from "./introduceDetail.vue?vue&type=script&lang=js&"
export * from "./introduceDetail.vue?vue&type=script&lang=js&"
import style0 from "./introduceDetail.vue?vue&type=style&index=0&id=07998c1a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07998c1a",
  null
  
)

export default component.exports